import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>Core values guide</p>
        <p className="attribution">
              This exercise was built by Christine Garibian, based on a Notion template found at: 
              <a href="https://simplesorted.gumroad.com/l/values?layout=profile" target="_blank" rel="noopener noreferrer">
                {' '}gumroad
              </a>
            </p>
      </div>
    </footer>
  );
};

export default Footer;